import React from 'react';
export function BeyondWrinkles() {
  return <div className="space-y-6" data-id="element-6">
      <h2 className="text-3xl font-bold text-gray-900" data-id="element-7">
        Beyond Wrinkles: What This Actually Does For Aging Skin
      </h2>
      <div className="w-full aspect-video bg-gray-200 rounded-lg flex items-center justify-center" data-id="element-8">
        <img src="https://cdn.shopify.com/s/files/1/0619/1693/8405/files/8_0291e586-3462-4e25-9f8c-b0da98104c36.png?v=1762311261" alt="Woman looking in mirror smiling" className="w-full h-full object-cover rounded-lg" data-id="element-9" />
      </div>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-10">
        What really impressed me wasn't just the wrinkle reduction.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-11">
        It was how this device addressed multiple aging concerns I didn't even
        realize were fixable:
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-12">
        Deep Hydration That Lasts
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-13">
        The multi-weight hyaluronic acid system reaches all three skin layers.
        My skin stays hydrated all day—even in winter when it used to be
        desperately dry.
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-14">
        Rebuilt Skin Structure
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-15">
        The peptide complex doesn't just fill wrinkles—it rebuilds six
        structural components that break down as we age. My skin feels thicker
        and more resilient.
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-16">
        That "Tired" Look Disappeared
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-17">
        The muscle-relaxing peptides released the tension in my face that made
        me look perpetually exhausted.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-18">
        Now I look rested, even on days when I'm not.
      </p>
      <h3 className="text-xl font-bold text-gray-900 pt-4" data-id="element-19">
        Improved Texture and Tone
      </h3>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-20">
        Age spots faded. Rough patches smoothed out. My complexion became more
        even and radiant.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed" data-id="element-21">
        It's not just about looking younger. It's about looking vibrant and
        healthy.
      </p>
      <p className="text-lg text-gray-800 leading-relaxed font-semibold" data-id="element-22">
        As someone who wants to age gracefully but not invisibly, this device
        strikes the perfect balance.
      </p>
    </div>;
}